import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route } from 'react-router-dom';
import { Routes } from '../node_modules/react-router-dom/dist/index';
import { HomePage } from "./pages/HomePage";
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, loginRequest } from "./authConfig";
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { slThemeLight } from './slTheme';
import { Layout } from './components/Layout';
import { AppContext, TheAppContext } from "./model/AppContext";
import { SmokeItPage } from './pages/SmokeItPage';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(
    async () =>
    {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0)
        {
            msalInstance.setActiveAccount(accounts[0]);
        }


        msalInstance.addEventCallback(
            (event: EventMessage) =>
            {
                if (event.eventType === EventType.LOGIN_SUCCESS && event.payload)
                {
                    const payload = event.payload as AuthenticationResult;
                    const account = payload.account;
                    msalInstance.setActiveAccount(account);

                    appContext.setAuth(payload.accessToken);
                }
            });

        const root = ReactDOM.createRoot(
            document.getElementById('root') as HTMLElement
        );

        const appContext = new AppContext(msalInstance);

        root.render(
            <React.StrictMode>
                <FluentProvider theme={slThemeLight}>
                    <TheAppContext.Provider value={appContext}>
                        <MsalProvider instance={msalInstance}>
                            <BrowserRouter>
                                <Routes>
                                    <Route path="/" element={<Layout />}>
                                        <Route index element={<HomePage />} />
                                        <Route path="SmokeItPage" element={<SmokeItPage />} />
                                    </Route>
                                </Routes>
                            </BrowserRouter>
                        </MsalProvider>
                    </TheAppContext.Provider>
                </FluentProvider>
            </React.StrictMode>
        );

        // If you want to start measuring performance in your app, pass a function
        // to log results (for example: reportWebVitals(console.log))
        // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
        reportWebVitals();
    }).catch((reason: any) =>
    {
        const root = ReactDOM.createRoot(
            document.getElementById('root') as HTMLElement
        );

        root.render((<div>Failed to initialize MSAL: {reason}</div>));
    });